import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_SplitButton, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.SplitButtonTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.SplitButtonTypeConst.CLASS) ?? '']: true }),
        name: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.SplitButtonTypeConst.DISABLED),
        placeholder: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.PLACEHOLDER),
        label: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.LABEL),
        icon: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.ICON),
        raised: _ctx.getPropertyBooleanValue(_ctx.SplitButtonTypeConst.RAISED),
        rounded: _ctx.getPropertyBooleanValue(_ctx.SplitButtonTypeConst.ROUNDED),
        outline: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.OUTLINE),
        text: _ctx.getPropertyBooleanValue(_ctx.SplitButtonTypeConst.TEXT),
        plain: _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.PLAIN),
        size: _ctx.getCatalogValue(_ctx.SplitButtonTypeConst.SIZE),
        model: _ctx.menuItems,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processEventComponent(_ctx.CatalogEventConst.CLICK)))
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "placeholder", "label", "icon", "raised", "rounded", "outline", "text", "plain", "size", "model"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.SplitButtonTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}